"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getName = getName;
exports.addName = addName;
exports.removeCustomerIfNoId = removeCustomerIfNoId;
exports.moveEventPropertiesToRoot = moveEventPropertiesToRoot;
exports.isNonEmpty = isNonEmpty;
exports.createFriendbuyPayload = createFriendbuyPayload;
exports.filterFriendbuyAttributes = filterFriendbuyAttributes;
exports.parseDate = parseDate;
exports.enjoinInteger = enjoinInteger;
exports.enjoinNumber = enjoinNumber;
exports.enjoinString = enjoinString;
function getName(payload) {
    return (payload.name ? payload.name :
        payload.firstName && payload.lastName ? `${payload.firstName} ${payload.lastName}`
            : undefined);
}
function addName(payload) {
    if (typeof payload === 'object' && !payload.name && payload.firstName && payload.lastName) {
        payload.name = `${payload.firstName} ${payload.lastName}`;
    }
}
function removeCustomerIfNoId(payload) {
    if (typeof payload !== 'object' || typeof payload.customer !== 'object' || payload.customer.id) {
        return payload;
    }
    payload = { ...payload };
    delete payload.customer;
    return payload;
}
function moveEventPropertiesToRoot(payload) {
    if (typeof payload !== 'object' || typeof payload.eventProperties !== 'object') {
        return payload;
    }
    const analyticsPayload = {
        ...(payload.eventProperties || {}),
        ...payload
    };
    delete analyticsPayload.eventProperties;
    return analyticsPayload;
}
function isNonEmpty(o) {
    if (o === undefined || o === '') {
        return false;
    }
    if (typeof o !== 'object') {
        return true;
    }
    for (const _e in o) {
        return true;
    }
    if (o === null) {
        return true;
    }
    return false;
}
function createFriendbuyPayload(payloadItems, flags = {}) {
    const friendbuyPayload = {};
    payloadItems.forEach(([k, v]) => {
        if (!(v === undefined || v === '' || (flags.dropEmpty && !isNonEmpty(v)))) {
            friendbuyPayload[k] = v;
        }
    });
    return friendbuyPayload;
}
function filterFriendbuyAttributes(api, friendbuyAttributes) {
    const filteredAttributes = [];
    if (friendbuyAttributes) {
        Object.entries(friendbuyAttributes).forEach((attribute) => {
            if (typeof attribute[1] === 'string') {
                if (attribute[0] === 'birthday') {
                    const dateRecord = parseDate(attribute[1]);
                    if (dateRecord) {
                        filteredAttributes.push([attribute[0], dateRecord]);
                    }
                }
                else {
                    filteredAttributes.push(attribute);
                }
            }
        });
    }
    return (filteredAttributes.length === 0 ? [] :
        api === 'mapi' ? [['additionalProperties', createFriendbuyPayload(filteredAttributes)]]
            : filteredAttributes);
}
const dateRegexp = /^(?:(\d\d\d\d)-)?(\d\d)-(\d\d)(?:[^\d]|$)/;
function parseDate(date) {
    if (typeof date === 'object' &&
        (!('year' in date) || typeof date.year === 'number') &&
        typeof date.month === 'number' &&
        typeof date.day === 'number') {
        return date;
    }
    if (typeof date !== 'string') {
        return undefined;
    }
    const match = dateRegexp.exec(date);
    if (!match) {
        return undefined;
    }
    const year = match[1] && match[1] !== '0000' ? { year: parseInt(match[1], 10) } : {};
    return { month: parseInt(match[2], 10), day: parseInt(match[3], 10), ...year };
}
const integerRegexp = /^-?(?:0|[1-9][0-9]*)$/;
const floatRegexp = /^-?(?:0|[1-9][0-9]*)(?:\.[0-9]+)?$/;
function enjoinInteger(input) {
    return typeof input === 'string' && integerRegexp.test(input) ? parseInt(input) : input;
}
function enjoinNumber(input) {
    return typeof input === 'string' && floatRegexp.test(input) ? parseFloat(input) : input;
}
function enjoinString(input) {
    return typeof input === 'number' ? input.toString() : input;
}
//# sourceMappingURL=util.js.map